<div class="table-responsive table-card mb-3">
	<table appResponsiveTable class="table align-middle table-striped table-hover mb-0 table-wrap">
		<thead>
			<tr class="bg-light text-muted">
				<th style="width: 14%">Date</th>
				<th style="width: 14%">Utilisateur</th>
				<th style="width: 12%">Action</th>
				<th style="width: 12%">Article</th>
				<th style="width: 14%">Champ</th>
				<th style="width: 17%">Valeur</th>
				<th style="width: 17%">Commentaire</th>
			</tr>
		</thead>
		<tbody>
			@if (isLoading) {
				<tr>
					<td colspan="20" class="text-center" style="padding: 14px 0px">Chargement encours...</td>
				</tr>
			} @else {
				@if (entrees.length === 0) {
					<tr>
						<td colspan="20" class="text-center" style="padding: 14px 0">Aucun historique</td>
					</tr>
				} @else {
					@for (entree of entrees; track entree.id) {
						<tr>
							<td>{{ entree.createdAt | date: "dd/MM/yyyy HH:mm" }}</td>
							<td>{{ entree.user?.nom || entree.user?.username || "—" }}</td>
							<td>
								<span class="badge rounded-pill fw-medium p-2" [ngClass]="action(entree).badge">{{ action(entree).label }}</span>
							</td>
							<td>{{ entree.ligneLibelle }}</td>
							<td>{{ champ(entree) }}</td>
							<td>
								@if (entree.champ) {
									<span class="text-muted">{{ valeur(entree, entree.ancienneValeur) }}</span>
									<i class="ri-arrow-right-line align-middle mx-1"></i>
									<span class="fw-medium">{{ valeur(entree, entree.nouvelleValeur) }}</span>
								}
							</td>
							<td class="text-wrap">{{ entree.commentaire }}</td>
						</tr>
					}
				}
			}
		</tbody>
	</table>
</div>
